import { Provider } from '@angular/core';

import { EpDataHttpService } from './abstract';
import { EpDataHttpServiceImpl } from './ep-data-http.service';

export const EpDataHttpProvider: Provider = {
	provide: EpDataHttpService,
	useClass: EpDataHttpServiceImpl,
};
